import React, { useState } from 'react';
import axios from 'axios';
import { API_URL } from '../../config/api';

const ContactForm = ({ onSuccess }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    role: '',
    use_case: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await axios.post(`${API_URL}/v1/contact`, formData);
      setSubmitted(true);
      if (onSuccess) onSuccess();
    } catch (err) {
      setError('Failed to submit. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="contact-success" data-testid="contact-success">
        <div className="success-icon">✓</div>
        <h3>Thank you!</h3>
        <p>We'll be in touch within 24 hours.</p>
      </div>
    );
  }

  return (
    <form className="contact-form" onSubmit={handleSubmit} data-testid="contact-form">
      <div className="form-row">
        <div className="form-group">
          <label>Name *</label>
          <input
            type="text"
            required
            value={formData.name}
            onChange={(e) => setFormData({...formData, name: e.target.value})}
            placeholder="Your name"
            data-testid="contact-name"
          />
        </div>
        <div className="form-group">
          <label>Email *</label>
          <input
            type="email"
            required
            value={formData.email}
            onChange={(e) => setFormData({...formData, email: e.target.value})}
            placeholder="you@company.com"
            data-testid="contact-email"
          />
        </div>
      </div>
      <div className="form-row">
        <div className="form-group">
          <label>Company</label>
          <input
            type="text"
            value={formData.company}
            onChange={(e) => setFormData({...formData, company: e.target.value})}
            placeholder="Company name"
            data-testid="contact-company"
          />
        </div>
        <div className="form-group">
          <label>Role</label>
          <select
            value={formData.role}
            onChange={(e) => setFormData({...formData, role: e.target.value})}
            data-testid="contact-role"
          >
            <option value="">Select role</option>
            <option value="analyst">Analyst / Researcher</option>
            <option value="pm">Portfolio Manager</option>
            <option value="comms">Communications / PR</option>
            <option value="developer">Developer</option>
            <option value="executive">Executive</option>
            <option value="other">Other</option>
          </select>
        </div>
      </div>
      <div className="form-group">
        <label>Use Case</label>
        <select
          value={formData.use_case}
          onChange={(e) => setFormData({...formData, use_case: e.target.value})}
          data-testid="contact-usecase"
        >
          <option value="">What are you looking to do?</option>
          <option value="investment">Investment Research</option>
          <option value="comms">Corporate Communications</option>
          <option value="policy">Policy Research</option>
          <option value="journalism">Journalism / Research</option>
          <option value="api">API Integration</option>
          <option value="other">Other</option>
        </select>
      </div>
      <div className="form-group">
        <label>Message</label>
        <textarea
          value={formData.message}
          onChange={(e) => setFormData({...formData, message: e.target.value})}
          placeholder="Tell us about your needs..."
          rows={4}
          data-testid="contact-message"
        />
      </div>
      {error && <p className="form-error">{error}</p>}
      <button type="submit" disabled={loading} className="submit-btn" data-testid="contact-submit">
        {loading ? 'Sending...' : 'Get in Touch'}
      </button>
    </form>
  );
};

export default ContactForm;
